<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import { CELLULITE_GRADE_OPTIONS } from '../types/cellulite-grade'

    export let data: Record<string, any>
</script>

<div class="cellulite-scale">
    {#each CELLULITE_GRADE_OPTIONS as option (option.key)}
        <div class="cellulite-row" class:selected={option.key === '02'}>
            <span class="cellulite-label">
                {option.label}
                <span class="cellulite-tooltip-icon"><Fa icon={faCircleQuestion} /></span>
            </span>
            <span class="cellulite-desc">{option.description}</span>
        </div>
    {/each}
</div>

<style>
    .cellulite-scale {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .cellulite-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        padding: 10px 14px;
        border-radius: 8px;
        background: #f8f9fa;
    }
    .cellulite-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .cellulite-label {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .cellulite-row.selected .cellulite-label {
        color: #1f2937;
    }
    .cellulite-desc {
        flex: 2;
        min-width: 0;
        text-align: right;
        font-size: 0.85rem;
        color: #495057;
    }
    .cellulite-row.selected .cellulite-desc {
        color: #1f2937;
    }
    .cellulite-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
    }
    .cellulite-row.selected .cellulite-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
</style>
